import { defineStore } from "pinia";
import { messengerMessageManager } from "@/services/messenger-message/messenger-message-manager";

export const useNotificationStore = defineStore({
  id: "Notification",
  state: () => {
    return {
      status: "",
      last: null,
      open: false,
      messages: [],
      list: [],
      listHasMore: false,
      listOpened: false,
      refreshComponentKey: 0,
      lastPingedMessage: null,
    };
  },

  actions: {
    setStatus(status) {
      this.status = status;
    },
    // Alimente la région live : n'écrire qu'au changement de statut d'un traitement, sinon deux
    // traitements suivis en parallèle font alterner l'annonce à chaque ping.
    setLastPingedMessage(message) {
      this.lastPingedMessage = message ? { id: message.id, label: message.label, status: message.status } : null;
    },
    incrementRefreshComponentKey() {
      this.refreshComponentKey = this.refreshComponentKey + 1;
    },
    setLast(notification) {
      this.last = notification;
    },
    setOpen(open) {
      this.open = open;
      if (this.status === messengerMessageManager.STATUS_SUCCESS && open) {
        this.setStatus(messengerMessageManager.STATUS_OFF);
      }
    },
    addMessage(message) {
      this.messages.unshift(message);
    },
    updateMessage(updatedMessage) {
      const index = this.messages.findIndex((m) => m.id === updatedMessage.id);
      if (index !== -1) {
        this.messages[index] = { ...this.messages[index], ...updatedMessage };
      }
    },
    setList(list) {
      this.list = list;
    },
    appendList(page) {
      const knownIds = new Set(this.list.map((message) => message.id));
      this.list.push(...page.filter((message) => !knownIds.has(message.id)));
    },
    setListHasMore(value) {
      this.listHasMore = value;
    },
    setListOpened(value) {
      this.listOpened = value;
    },

    init() {
      this.status = "";
      this.last = null;
      this.open = false;
      this.messages = [];
      this.list = [];
      this.listHasMore = false;
      this.listOpened = false;
      this.refreshComponentKey = 0;
      this.lastPingedMessage = null;
    },
  },
});
